// src/components/content-wrappers/ArgotCard.jsx
import React from 'react';

const ArgotCard = () => {
  return (
    <div className="min-h-screen bg-gray-200 flex items-center justify-center p-10">
      
      {/* --- THE GRAPHIC CARD (Screenshot this area) --- */}
      <div className="bg-white w-[600px] h-[600px] p-12 rounded-none shadow-2xl relative flex flex-col justify-between border-t-8 border-indigo-900 font-serif">
        
        {/* Header / Watermark */}
        <div className="absolute top-6 right-8 text-gray-300 font-sans font-bold tracking-widest text-xs uppercase">
          Aulice Pro Mastery
        </div>

        {/* Main Content */}
        <div className="mt-8">
          {/* Title Pair */}
          <h1 className="text-5xl font-black text-gray-900 mb-2 tracking-tight">
            Excavation <span className="text-4xl text-gray-400 font-light italic">vs</span> Hole
          </h1>
          {/* Pronunciation Guide */}
          <p className="text-gray-500 text-lg italic mb-10 font-sans">/ˌek.skəˈveɪ.ʃən/ • /hoʊl/</p>

          {/* Definitions */}
          <div className="space-y-8 font-sans">
            
            {/* Entry 1: Excavation */}
            <div className="flex items-start gap-4">
              {/* Icon for Engineering/Construction */}
              <div className="bg-orange-100 p-3 rounded-lg text-2xl">👷‍♂️</div>
              <div>
                <span className="font-bold text-xl text-indigo-900">Excavation</span>
                <span className="text-gray-500 text-sm ml-2 italic">(noun)</span>
                <p className="text-gray-700 mt-1 text-xl leading-relaxed">
                  An <span className="font-bold bg-orange-50 px-1 border-b-2 border-orange-300">engineered</span> removal of earth for a specific purpose.
                  <span className="block text-sm text-gray-400 mt-1 uppercase tracking-wide font-bold">Scope: Planned & Professional</span>
                </p>
              </div>
            </div>

            {/* Entry 2: Hole */}
            <div className="flex items-start gap-4">
              {/* Icon for something random/accidental */}
              <div className="bg-gray-100 p-3 rounded-lg text-2xl">🕳️</div>
              <div>
                <span className="font-bold text-xl text-gray-600">Hole</span>
                <span className="text-gray-500 text-sm ml-2 italic">(noun)</span>
                <p className="text-gray-700 mt-1 text-xl leading-relaxed">
                  A simple, often accidental or unplanned opening in the ground.
                  <span className="block text-sm text-gray-400 mt-1 uppercase tracking-wide font-bold">Scope: Random & Unplanned</span>
                </p>
              </div>
            </div>

          </div>
        </div>

        {/* The Twist / Footer */}
        <div className="mt-8 border-l-4 border-red-500 pl-6 py-2 bg-gray-50">
          <p className="text-red-700 font-bold font-sans uppercase text-xs tracking-wider mb-1">
            ⚠️ The Twist
          </p>
          <p className="text-gray-800 font-medium font-sans text-lg italic">
            "Stop sounding like a tourist. Speak like an Engineer."
          </p>
        </div>

        {/* Branding Footer */}
        <div className="flex justify-between items-end mt-4 pt-6 border-t border-gray-100">
          <div className="text-gray-400 text-sm font-sans">aulice.ca</div>
          <div className="text-indigo-900 font-bold font-sans">AULICE ACADEMY</div>
        </div>

      </div>
      {/* --- END OF GRAPHIC --- */}

    </div>
  );
};

export default ArgotCard;